import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, inject, input, OnDestroy, OnInit, output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AutofocusDirective } from '@zero/shared/ui-directives';
import { ButtonComponent, IconComponent, TagComponent } from '@zero/shared/ui-web-design-system';
import { TagsFacade } from '@zero/tags/domain';
import { firstValueFrom } from 'rxjs';
import { TagNameFilterPipe } from '../../pipes/tag-name-filter/tag-name-filter.pipe';
import { TagNameValidPipe } from '../../pipes/tag-name-valid/tag-name-valid.pipe';
import { TagsByEntityPipe } from '../../pipes/tags-by-entity/tags-by-entity.pipe';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[tags-link-tag]',
  imports: [
    AsyncPipe,
    TagComponent,
    ButtonComponent,
    IconComponent,
    TranslocoPipe,
    FormsModule,
    NgbDropdownModule,
    AutofocusDirective,
    TagNameValidPipe,
    TagNameFilterPipe,
    TagsByEntityPipe,
  ],
  templateUrl: './link-tag.component.html',
  styleUrl: './link-tag.component.scss',
})
export class LinkTagComponent implements OnInit, OnDestroy, AfterViewInit {
  public readonly facade = inject(TagsFacade);
  public readonly entityId = input.required<string>();
  public readonly currentlyEditingTag = input<string | null>();
  public readonly cancelLinking = output<MouseEvent>();

  public tagName: string;
  public linkedTagsSuggestionsVisible = false;

  @ViewChild('dropdownTrigger') public dropdownTrigger?: NgbDropdown;

  ngOnInit() {
    this.facade.setEntityId(this.entityId());
  }

  ngOnDestroy() {
    this.facade.resetEntityId();
    this.clearErrors();
  }

  ngAfterViewInit(): void {
    this.dropdownTrigger?.open();
  }

  public addExistingTag(tagId: string, name: string) {
    this.facade.addTag(tagId, this.entityId(), name);
  }

  public async addTag() {
    const existingTag = (await firstValueFrom(this.facade.notUsedTags$))?.find((tag) => tag.name === this.tagName);
    this.facade.addTag(existingTag?.tagId ?? null, this.entityId(), this.tagName);
    this.tagName = '';
  }

  public clearErrors() {
    this.facade.clearErrors();
  }
}
